<template>
    <div id="footer">
        <div class="row">
            <div id="footer-icon-m-pad" class="m-pad">
                <div id="footer-icons" class="base icons margin-l">
                    <a href="https://www.facebook.com/LACountyRRCC/" target="_blank"><img title="Facebook" alt="Icon - Facebook" src="@/assets/images/icon_facebook.png"/></a>
                    <a href="https://twitter.com/lacountyrrcc" target="_blank"><img title="Twitter" alt="Icon - Twitter" src="@/assets/images/icon_twitter.png"/></a>
                    <a href="https://instagram.com/lacountyrrcc" target="_blank"><img title="Instagram" alt="Icon - Instagram" src="@/assets/images/icon_instagram.png"/></a>
                    <a href="https://www.yelp.com/biz/los-angeles-county-registrar-recorder-county-clerk-norwalk" target="_blank"><img title="Yelp" alt="Icon - Yelp" src="@/assets/images/icon_yelp.png"/></a>
                    <a href="https://www.youtube.com/user/lacountyrrcc" target="_blank"><img title="YouTube" alt="Icon - YouTube" src="@/assets/images/icon_youtube.png"/></a>
                </div>
                <div class="landscape right">
                    <a id="footer-landscape-r" class="base button-contact" href="https://www.lavote.net/contact-us/contact-us" target="_blank">
                        <div class="base">
                            <img src="@/assets/images/icon_call_us.png" alt="Icon - Call Us" title="Call Us" width="30" height="30"/>
                        </div>
                        <div class="base label">
                            <span>{{ $t("Template.Navigation.ContactUs") }}</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
}
</script>